import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./includes/Header";
import Footer from "./includes/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Products from "./pages/Products";
import Contact from "./pages/Contact";
import ProductDetail from "./pages/ProductDetail";

function App() {
  return (
    <div>
      <BrowserRouter>
        <Header />
        <Routes>
          <Route exact path="/" Component={Home} />
          <Route exact path="About" Component={About} />
          <Route exact path="Products" Component={Products} />
          <Route exact path="Contact" Component={Contact} />
          <Route exact path="Product-Detail" Component={ProductDetail} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
